import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

import { useNotification } from 'hooks/notifications/useNotification'
import { useTranslationRankmi } from 'helpers/translations.helper'

export interface Dc3PublishLocationState {
  dc3PublishNotification?: {
    courseName: string
  }
}

const publishNormativeModalPrefix =
  'administration.lessons.publishNormativeModal'

/**
 * Muestra la notificación de curso publicado sin DC-3 cuando se navega
 * desde lecciones con state en la ruta (sin Redux).
 */
export const useDc3PublishNotificationFromRoute = () => {
  const location = useLocation<Dc3PublishLocationState>()
  const history = useHistory()
  const notification = useNotification()
  const t = useTranslationRankmi({ prefix: publishNormativeModalPrefix })

  useEffect(() => {
    const courseName = location.state?.dc3PublishNotification?.courseName
    if (!courseName) {
      return
    }

    notification.successWithDescription(
      t('notification.title', { courseName }),
      t('notification.body')
    )

    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    })
  }, [history, location, notification, t])
}

export default useDc3PublishNotificationFromRoute
